import { Collection } from "../../entity/Collection";
import { toDate } from "../../utils/GlobalFunctions";
import { Method } from "../configuration/Configuration";
import { CollectionDto } from "../dto/Collection.Dto";

export const mapToCollection = (data: CollectionDto[]): Collection[] => {
  return data.map((item) => ({
    id: item.id,
    name: item.name,
    description: item.description,
    type: getMethodType(item.type),
    isActive: item.isActive,
    createdAt: toDate(item.createdAt),
    updatedAt: toDate(item.updatedAt),
    fields: item.fields,
    companyId: item.companyId,
    path: item.path,
  }));
};

const getMethodType = (type: string) => {
  switch (type.toUpperCase()) {
    case "GET":
      return Method.GET;
    case "POST":
      return Method.POST;
    case "PUT":
      return Method.PUT;
    case "DELETE":
      return Method.DELETE;
    default:
      throw new Error(
        `Invalid method type: ${type}. Must be one of: GET, POST, PUT, DELETE`,
      );
  }
};
